import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useConfig } from '../context/ConfigContext';
import { useAuth } from '../context/AuthContext';
import Header from '../components/Header';
import Countdown from '../components/Countdown';
import ActionButton from '../components/ActionButton';
import VideoCard from '../components/VideoCard';
import api from '../api/axios';

const Home = () => {
    const navigate = useNavigate();
    const { config } = useConfig();
    const { user } = useAuth(); 
    const [eventDate, setEventDate] = useState('2026-06-05T08:00:00');
    const [activeVideo, setActiveVideo] = useState(null);

    useEffect(() => {
        const fetchClosestAgendaDate = async () => {
            try {
                const res = await api.get('/agenda?status=active');
                if (res.data && res.data.length > 0) {
                    const sorted = [...res.data].sort((a, b) => {
                        const dateA = new Date(`${a.date.split('T')[0]}T${a.start_time}`);
                        const dateB = new Date(`${b.date.split('T')[0]}T${b.start_time}`);
                        return dateA - dateB;
                    });
                    const firstEvent = sorted[0];
                    setEventDate(`${firstEvent.date.split('T')[0]}T${firstEvent.start_time}`);
                }
            } catch (err) {
                console.error("Error fetching agenda for countdown", err);
            }
        };
        fetchClosestAgendaDate();
    }, []);

    const videos = config?.pageDesigns?.home?.videos || [];

    return (
        <div className="flex flex-col items-center justify-start pb-24 min-h-screen animate-fadeIn w-full">

            <div className="w-full max-w-2xl px-4 flex flex-col items-center mt-4">
                
                {/* Countdown Module */}
                <Countdown targetDate={eventDate} />

                {/* Info Buttons */}
                {videos.filter(v => v.active).length > 0 && (
                    <div className="flex flex-wrap gap-4 w-full justify-center my-6">
                        {videos.filter(v => v.active).map((video, idx) => (
                            <ActionButton 
                                key={idx} 
                                variant="secondary" 
                                onClick={() => setActiveVideo(video)} 
                                className="!max-w-[200px] !text-sm !py-3 uppercase"
                            >
                                {video.title}
                            </ActionButton>
                        ))}
                    </div>
                )}

                {/* Video Cards Grid removed as per request to make dynamic buttons */}

                {/* Call to Action */}
                <div className="w-full mt-8 bg-black/30 backdrop-blur-md rounded-[40px] p-8 border border-white/10 text-center">
                    <h3 className="text-xl font-bold text-white mb-4">
                        Sea parte del lazo que transformará el ecosistema de las <span className="text-orange-400 font-black">Enfermedades Raras</span>
                    </h3>
                    
                    <ActionButton variant="primary" onClick={() => navigate('/agenda')} className="mt-6">
                        Agendar fecha
                    </ActionButton>
                </div>
            </div>

            {/* Video Modal */}
            {activeVideo && (
                <div className="fixed inset-0 z-[100] flex items-center justify-center bg-black/90 p-4 animate-fadeIn" onClick={() => setActiveVideo(null)}>
                    <div className="relative w-full max-w-4xl bg-black rounded-2xl overflow-hidden aspect-video shadow-2xl" onClick={e => e.stopPropagation()}>
                        <button 
                            className="absolute top-4 right-4 z-10 w-10 h-10 bg-black/50 text-white rounded-full flex items-center justify-center font-bold hover:bg-white/20 transition-all backdrop-blur-md"
                            onClick={() => setActiveVideo(null)}
                        >
                            ✕
                        </button>
                        <iframe
                            src={activeVideo.videoUrl}
                            title={activeVideo.title}
                            className="w-full h-full border-none"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                            allowFullScreen
                        />
                    </div>
                </div>
            )}
        </div>
    );
};

export default Home;
